// extracted by mini-css-extract-plugin
module.exports = {"LinkButton":"LinkButton","LinkButtonInner":"LinkButtonInner","MaterialButton-root":"MaterialButton-root","MuiButton-root":"MuiButton-root"};